<template lang="pug">
  v-dialog(v-model="$_show" :max-width="width")
    v-card(light)
      v-card-text 
        slot
      v-card-actions
        v-spacer
        v-btn.text-none(color="#757575" text @click="$_show = false") Отмена
        v-btn.text-none.sud-dialog-card__action--delete(color="#0E9DBC" small depressed  @click="handleConfirm") {{ confirmButton }}
</template>

<script>
import AppDialogToggable from './AppDialogToggable'

export default {
  mixins: [AppDialogToggable],
  name: 'app-dialog-confirm',

  props: {
    confirmButton: {
      type: String,
      default: 'Подтвердить'
    },
    width: {
      type: [String, Number],
      default: 400
    }
  },

  methods: {
    handleConfirm () {
      this.$_show = false
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.sud-dialog-card__action--delete {
  margin: 0px 8px 0px 8px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FFFFFF;
}
</style>